<!-- 二维码登录页 -->
<template>
<div class="webmain" >
   <div class="header">
     <section>
        <div class="imgUtl">
           <a href="https://www.kangou.cn/"><img src="@/assets/img/images/logo_fl.png" style="width:122px; height: 32px" alt=""></a>
           <a href="https://www.kangou.cn/"><img src="@/assets/img/images/logo_movie.png" style="width: 133px; height: 30px;margin-left: 30px;" alt=""></a>
       </div>
       <div class="movie-kan">
         <!-- <span><a href="https://www.kangou.cn/cinema.shtml">电影</a></span> -->
       <!-- <span><a href="https://www.kangou.cn/website/profile">关于看购</a></span> -->
       </div>
       <div class="login_nav">
         <!-- <el-button type="danger" icon="el-icon-user">登录</el-button> -->
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              用户名 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
               <el-dropdown-item command="a">个人中心</el-dropdown-item>
              <!-- <el-dropdown-item  command="b">管理1</el-dropdown-item>
              <el-dropdown-item command="c">管理2</el-dropdown-item> -->
              <el-dropdown-item  command="d" >退出登录</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
       </div>
     </section>
   </div>
   <div class="main" :style="{backgroundImage: 'url(' + bgimg  +')'}">
      <div class="image_url">
        <img src="@/assets/img/images/kg_index_img1.png" alt="" class="china">
      </div>

      <div class="webwxmain">
          <iframe sandbox="allow-scripts allow-top-navigation allow-same-origin allow-popups allow-forms" scrolling="no" class="webiframe" frameborder="0"  allowtransparency="true" :src="this.access_uri"></iframe>  
      </div>
   </div>
   <div class="footer">
     <div class="footer_text"><a href="#">看购福利</a>|<a href="#">联系销售</a>|<span>京ICP备12023713号-2</span>|<span>京公网安备11010502025658</span></div>
   </div>
</div>
</template>

<script>
 import * as api from '@/api'
 import { mapMutations } from 'vuex';
 import JmmToast from '@/components/JmmToast'
 import wxlogin from 'vue-wxlogin';

 import bgimg from '@/assets/img/images/login_newbj.jpg'
  export default {
    name: 'weblogin',
    data () {
      return {
       redirect_uri:'',
       access_type:'login',
       access_uri:'',
       bgimg: bgimg, 
       //本地地址
       localUrl: process.env.LOCAL_URL,
       merchantId: '',
       stateId: ''
      }
    },
    created() {
      this.merchantId = this.$route.query.merchantId;
      this.stateId = this.$route.query.state;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
        this.merchantId = this.stateId;
        localStorage.setItem('cityMerchantId', this.merchantId);
      } else {
        localStorage.setItem('cityMerchantId', "");
      }
      this.redirect_uri = this.$route.query.redirect_uri;
      this.access_type = this.$route.query.access_type;
      this.access_uri = this.$route.query.access_uri;
    },
    components: {
      wxlogin
    },
    computed: {
   
    },
    mounted() {
      const _this=this;
      window.gourl=_this.gourl;
      _this.init();
    },
    methods: {
       handleCommand(command) {
        console.log('click on item ' + command)
      },
      init(){

      if(localStorage.getItem("reSESSIONKEY")==""){
         localStorage.clear();
      }
     
      if(this.access_type=="cardbind"){
         this.access_uri="webcardbind.html#/?merchantId" + this.merchantId;
      }
      else if(this.access_type=="cardlogin"){
         this.access_uri="webcardlogin.html#/?merchantId" + this.merchantId;
      }
      else{
        if(localStorage.getItem("reSESSIONKEY")!=null){
          
          this.access_uri="webcardlogin.html#/?merchantId" + this.merchantId;
        }
        else{
          var local = this.localUrl + "/webcardlogin.html#/?merchantId" + this.merchantId;
          if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
            // 获取授权后的code位置
            var codeBeg = local.indexOf("?code=");
            var codeEnd = local.indexOf("#/?");
            // 截取授权后的code数据
            var codeCut = local.substring(codeBeg, codeEnd);
            local = local.replace(codeCut, "");
          }
          this.access_uri=`https://open.weixin.qq.com/connect/qrconnect?appid=wxec7e055bb57fcca7&scope=snsapi_login&redirect_uri=${encodeURIComponent(local)}&state=${this.merchantId}&login_type=jssdk&style='black'&self_redirect=true&href=data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDgwJTsgbWFyZ2luOjB9Ci5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogODAlO30K`;
        }
         
      }
    


      },
       
      gourl() {
           this.redirect_uri=this.redirect_uri == undefined ? "https://amuse.kangou.cn/#/" : this.redirect_uri;
           window.top.location.href=this.redirect_uri+"?sessionkey="+localStorage.getItem('reSESSIONKEY');
         
      }
  
    },
   
  }
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

html{
  height :100%;
  background :#fff;
}

body {
  height :100%;
  overflow: hidden;
}

.webmain{
    width:100%;
    height :100%; 
    display :flex;
    flex-direction : column;
}

.webwxmain{
   width :500px;
   min-height :500px;
   height:auto;
   background-color :#ffffff;
   padding: 35px 0  15px 0;
   border-radius : 10px;
   display :flex;
   justify-content: center;
}

.webiframe{
  width :450px;
  height :480px;
}

.main {
  width: 100%
  display: flex;
  justify-content: space-around;
  align-items :center;
   
  // background-image:url('../../assets/img/images/login_newbj.jpg'); 
  background-repeat:no-repeat;
  background-size :100% 100%;
}

.move_header, .footer {
  height : 11%;
  width: 100%;
}
.china {
 width : 95%;
}
.footer {
  display: flex;
  justify-content: center;
  align-items :center;
}
.footer_text {
  width :700px;
  text-align: center;
  font-size: 16px;
  color : #777;

  display : flex;
  justify-content : space-around;
  align-items :center;
}

.footer_text a {
  font-size: 17px;
  color : #777;
}

.login_nav {
  text-align center;
}
.login_nav .el-button {
  width : 150px;
}
.header {
  flex : 1;

  display :flex;
  justify-content : center;
  align-items : center;
}

.movie-kan span, .el-dropdown-link{
  font-weight : bold;
  font-size : 18px;
  margin-right : 65px;
}
.movie-kan span:hover{
  color: #52a7dc;
}

.header section {
  // width :1200px !important;
  width : 78vw;
  display :flex;
  justify-content: space-between;
  align-items : center;
}

.main {
  flex : 7;
}
 
 .footer1 {
  flex : 1;
 }

 @media screen and (max-width: 1240px) {
   html {
     overflow :hidden;
   }
   .header section {
      width :1280px !important;
    }

    .china {
      width: 616px;
      height: 292px;
    }
    
    .imgUtl {
      width : 450px;
    }
    
    .movie-kan {
      width : 220px;
    }

    .footer_text a{
      width :80px !important;
    }

    .footer_text {
      width :700px;
    }

 }
</style>



// WEBPACK FOOTER //
// src/view/weblogin/index.vue